import { createElement } from "@wordpress/element";
/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { forwardRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import * as ProgressBarStyled from './styles';
function UnforwardedProgressBar(props, ref) {
  const {
    className,
    value,
    ...progressProps
  } = props;
  const isIndeterminate = !Number.isFinite(value);
  return createElement(ProgressBarStyled.Track, {
    className: className
  }, createElement(ProgressBarStyled.Indicator, {
    isIndeterminate: isIndeterminate,
    value: value
  }), createElement(ProgressBarStyled.ProgressElement, {
    max: 100,
    value: value,
    "aria-label": __('Loading …'),
    ref: ref,
    ...progressProps
  }));
}
export const ProgressBar = forwardRef(UnforwardedProgressBar);
export default ProgressBar;
//# sourceMappingURL=index.js.map